import { ReducerBuilder } from './reducerBuilder';
import { SharingDataRequest } from 'acscp/api/requests';
import { SharingDataList } from 'acscp/api/models/sharingDataList';
import { PreviousSharingEmailState } from 'acscp/store/sharingDataState';

export const previousEmailsReducer =
    new ReducerBuilder<PreviousSharingEmailState>({emails: []})
    .successfulRequestCase(SharingDataRequest, (state, sharingDataList: SharingDataList) => ({
            ...state,
            emails: sharingDataList.previousEmails
        }))
    .build();
